export default function FirelineSystem() {
  const emailTypes = [
    {
      icon: 'ri-calendar-check-line',
      title: 'Daily Short-Form Emails',
      description: 'Brief, readable messages that respect your customers\' time.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Educational Compliance Reminders',
      description: 'Keep customers informed about regulations and requirements.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Behind-the-Scenes Service Insights',
      description: 'Show the expertise and care that goes into every job.'
    },
    {
      icon: 'ri-compass-line',
      title: 'Transparency-Based Positioning',
      description: 'Build trust through honest, straightforward communication.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Trust-Building Stories',
      description: 'Share real experiences that demonstrate your values and expertise.'
    },
    {
      icon: 'ri-file-list-line',
      title: 'Service Agreement Reinforcement',
      description: 'Remind customers why ongoing maintenance matters.'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            The Fireline Email System
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            A structured approach to staying top-of-mind with your customers through consistent, valuable communication.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {emailTypes.map((type, index) => (
            <div
              key={index}
              className="bg-gray-50 p-8 rounded-lg border border-gray-200 hover:border-red-600 transition-colors"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-lg mb-6">
                <i className={`${type.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{type.title}</h3>
              <p className="text-gray-600 leading-relaxed">{type.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 text-white p-12 rounded-lg text-center">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-3xl font-bold mb-6">Not Newsletters. Not Promotions. Not Fluff.</h3>
            <p className="text-xl text-gray-300 mb-4">
              This is <strong className="text-red-400">relationship infrastructure</strong>.
            </p>
            <p className="text-lg text-gray-400">
              Every email is designed to build trust, demonstrate expertise, and keep your company at the forefront of your customers' minds.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}